var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3438 9L17.0312 4.3125C17.6406 3.75 17.6406 2.8125 17.0312 2.25L16 1.21875C15.4375 0.609375 14.5 0.609375 13.9375 1.21875L9.25 5.90625L4.51562 1.21875C3.95312 0.609375 3.01562 0.609375 2.45312 1.21875L1.42188 2.25C0.8125 2.8125 0.8125 3.75 1.42188 4.3125L6.10938 9L1.42188 13.7344C0.8125 14.2969 0.8125 15.2344 1.42188 15.7969L2.45312 16.8281C3.01562 17.4375 3.95312 17.4375 4.51562 16.8281L9.25 12.1406L13.9375 16.8281C14.5 17.4375 15.4375 17.4375 16 16.8281L17.0312 15.7969C17.6406 15.2344 17.6406 14.2969 17.0312 13.7344L12.3438 9Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.a16e2131a21dd92e67a2de9e7e85e214.svg";
export { ForwardRef as ReactComponent };